export const SUPPORTED_LANGUAGES = ['tr', 'en'] as const
export type SurfaceLanguage = typeof SUPPORTED_LANGUAGES[number]

export const DEFAULT_CULTURE_BY_LANGUAGE = {
  tr: 'tr-TR',
  en: 'en-US',
} as const satisfies Record<SurfaceLanguage, string>

export function isSurfaceLanguage(value: unknown): value is SurfaceLanguage {
  return typeof value === 'string' && SUPPORTED_LANGUAGES.some((language) => language === value)
}

/** Reject malformed tags and languages Intl would silently replace with the host locale. */
export function normalizeCulture(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value || value.length > 128) return undefined
  try {
    const [culture] = Intl.getCanonicalLocales(value)
    return culture && Intl.DateTimeFormat.supportedLocalesOf([culture], { localeMatcher: 'lookup' }).length
      ? culture
      : undefined
  } catch (error) {
    if (error instanceof RangeError) return undefined
    throw error
  }
}
